module.exports = __webpack_public_path__ + "static/media/mainbanner_keyword_object.c503abbf.png";